import * as types from './actionTypes';

const initialState = {
  monthlyDeduction: null,
  deductionList:[],
  importlist: [],
  loading: false,
  error: null,
  success: false,
};

const monthlyDeductionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION:
    case types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION:
    case types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS:
    case types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION_SUCCESS:
      return {
        ...state,
        //monthlyDeduction: action.payload?.data,
        loading: false,
        success: true,
        monthlyDeduction: (action.payload?.data).map(ded => ({
          enable_status: true,
          entry_type: 1,              
          ded_id:0,
          emp_code:ded.emp_no,
          emp_no: {value:ded.emp_id,label:ded.emp_no+' - '+ded.emp_name},          
          emp_id: ded.emp_id,
          emp_name: ded.emp_name,
          amount: ded.amount,
          pay_ded_id: ded.pay_ded_id,         
          remarks: ded.remarks
        })),
      };

    case types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION_SUCCESS:
       return {
        ...state,
        loading: false,
        success: true,        
      };
    case types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,        
      };
    case types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION_FAILURE:
    case types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION_FAILURE:
    case types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS_FAILURE:
    case types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      }; 
      
    case types.PAYROLL_DEDUCTION_IMPORT_MONTHLY:
    case types.PAYROLL_DEDUCTION_IMPORT_MONTHLY_SUCCESS:
      return { ...state, loading: false, success: false, importlist: action.payload?.data || [] };
    case types.PAYROLL_DEDUCTION_IMPORT_MONTHLY_FAILURE:

    case types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE:
    case types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE_SUCCESS:
      return { ...state, loading: false, success: false, template: action.payload };
    case types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE_FAILURE:

    default:
      return state;
  }
};

export default monthlyDeductionReducer;
